class VideoModule
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'video-module--bound'
            @.$playButton = @.$el.querySelector '.video-module__play-button'
            @.$video = @.$el.querySelector 'video'

            @.loaded = @.$el.classList.contains 'video-module--loaded'
            @.playing = false

            @.$el.classList.add 'video-module--bound'
            @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        if !@.loaded
            @.$playButton.addEventListener 'click', (e) ->
                self.PlayVideo()
                return

        @.$video.addEventListener 'pause', (e) ->
            if !@.seeking
                self.$el.classList.remove 'video-module--playing'
                self.playing = false
            return
            
        window.addEventListener 'stopAllVideos', (e) ->
            self.PauseVideo()
            return
        return

    PauseVideo: ->
        if @.playing
            @.$video.pause()
            @.$el.classList.remove 'video-module--playing'
            @.playing = false
        return

    PlayVideo: ->
        @.$el.classList.add 'video-module--playing'
        @.playing = true
        @.$video.play()
        return

BindVideoModules = ->
    document.querySelectorAll '.video-module:not(.video-module--bound)'
        .forEach (el) ->
            new VideoModule el
            return
    return

window.addEventListener 'bind-components', BindVideoModules